import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './routes'
import GlobalComponent from "../../common/components.add.js";
import "../../plugins/index";
// store import
import store from "../../store";

Vue.config.productionTip = false

// UI 컴퍼넌트 전역 등록
GlobalComponent.init();

new Vue({
    router,
  render: h => h(App),
}).$mount('#app')
